<template>
  <div class="geoff-bg-section">
    <div 
      v-for="(event, index) in events" 
      :key="index"
      class="event-line geoff-border-bottom py-2 px-n "
      @click="goToEvent(event)"
    >
        <div class="section-line">
          <div v-html="event?.sportSvg" class="sport-icon"></div>
          <div>{{ event.inPlayMatchName }}</div>
        </div>
        <svg-icon class="icon-to-right-arrow" icon-name="to-right-arrow"/>
    </div>

  </div>
</template>

<script>
  import SvgIcon from "@/components/UI/SvgIcon";

  export default {
  name: "InplayUpcomingEventsList",
    components: { 
      SvgIcon
    },
    props:{
      events: {
        type: Array,
        default: () => { return  []}
      },
    },
    methods: {
      goToEvent(event){
        const sport =  this.API.SPORTS.find(sport => sport?.antePostCode === event.sportcode || sport?.code === event.sportcode)
        if (event?.isFutures) {
          this.$router.push({
            name: 'antepostEvent', 
            params: {
              sportName:sport.title,
              ef: event.eventFile, 
              eg: event.eventGroup
            }, 
            query: {
              antepostTitle: event.originalName
            }})
        
        }
        else {
          this.$router.push({
            name: 'matchEvent',
            params: {
                sportName: sport.title,
                ef: event.eventFile,
                eg: event.eventGroup
              },
            query: {
                title: event.inPlayMatchName,
              }
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .event-line {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .section-line {
      display: flex;
      gap: 0.5rem;
      .sport-icon {
            width: 1.375rem;
            height: 1.375rem;
            display: flex;
        }
      }

    .icon-to-right-arrow {
      height: 0.875rem;
      width: 0.875rem;
      opacity: 0.5;
    }
  }
</style>